import * as React from 'react';
import {ApolloProvider} from 'react-apollo';
import ReactDOM from 'react-dom';
import {Provider} from 'react-redux';

import {ApolloProvider as ReactHooksApolloProvider} from '@apollo/react-hooks';

import {nutApolloClient} from '../../../apollo-client';
import {store} from '../../../store';

import {SetupSourcesPage} from './setup-sources-page';

export function mountSetupSources() {
    const sourcesContainer = document.querySelector('#react-mount-setup-sources');

    if (sourcesContainer) {
        ReactDOM.render(
            <Provider store={store}>
                <ApolloProvider client={nutApolloClient}>
                    <ReactHooksApolloProvider client={nutApolloClient}>
                        <SetupSourcesPage />
                    </ReactHooksApolloProvider>
                </ApolloProvider>
            </Provider>,
            sourcesContainer
        );
    }
}
